import {useCallback, useMemo} from 'react';
import {makeStyles, Tooltip} from '@material-ui/core';
import clsx from 'clsx';
import {useStylesTooltip} from "../../../config/theme";
import {useSelector} from "react-redux";
import UtilService from "../../../helper/service";
import useWindowSize from '../../../helper/hooks/useWindowSize';

const useStyles = makeStyles(() => ({
  header: {
    background: '#fff',
    borderRadius: '10px 10px 0px 0px',
  },
  headerContent: {
    height: 65,
    fontSize: 12,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#606B76',
    textTransform: 'uppercase',
    textAlign:'center',
    '& div': {
      textAlign: 'center'
    },
    '@media (max-width: 1025px)': {
      height: 38,
      fontSize: 9,    
    },
  },
  headerBorder: {
    flex: 1,
    height: 1,
    background: '#D9D9D9',
    margin: '0 12px'
  },
  p8: {
    // padding: '0 8px'
  },
  headerName: {
    // color: '#017AEF',
    display: 'flex',
    justifyContent: 'space-between',
  },
  separator: {
    background: '#D9D9D9',
    height: '100%',
  },
  separatorImmersion: {
    left: -1
  },
  separatorSafety: {
    left: -2
  },
  textLeft: {
    textAlign: 'left',
    marginLeft: 4

  },
  rotate180: {
    transform: 'rotate(180deg)',
  },
  subClass: {
    height: 40,
    background: '#E4E9EF'
  },
  searchClass: {
    height: 65,
  },
  cursor: {
    cursor: 'pointer'
  },
  headerItem: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center'
  },
  sortIcon: {
    marginLeft: 4,
    width: 16,
    height: 15,
    '@media (max-width: 1025px)': {
      width: 12,
      height: 11,   
    },
  }
}));

export function CompareTableHeader(props: any) {

  const classes = useStyles();
  const tooltipClasses = useStylesTooltip();
  const { onClickFilter, currentFilterArray, data, sub, search, category, onCategoryChanged, showSafety } = props;
  const { currentSession, cliped } = useSelector((state: any) => state.analysis);
  const { session_type, session_length } = currentSession;
  const {width} = useWindowSize();

  const tableData = useMemo(() => {
    const filter = category === 'immersion' ? 'safety' : 'immersion';
    return data.filter((item: any) => item.category !== filter && ((item.category === 'safety' || item.title === 'safety' || item.category === 'separator') ? showSafety === true : true))
  }, [data, category, showSafety])

  const getFilerDirection = (item: any) => {
    return (item.title.toLowerCase() === currentFilterArray.compareFilter.toLowerCase()) && currentFilterArray.filterDirection ;
  };

  const onShowSafety = useCallback(() => {
    const length = cliped ? Number(cliped.end_clip - cliped.start_clip) : Number(session_length);
    return UtilService.isShowSafety(session_type, length);
  }, [session_type, session_length, cliped]);

  return (
    <div className={clsx(classes.header, !sub && classes.p8)} >
      <div className={clsx(classes.headerContent, (search && sub) && classes.searchClass, sub && classes.subClass)}>
        {
          tableData.map((item: any, index: number) =>
            onShowSafety() ? (
              <div
                key={index}
                style={{ justifyContent: (item.title === 'name') ? 'left' : 'center', ...(item.title === 'name' ? { flex: 1 } : { width: (width <= 1025) ? item.mobileWidth : item.width }) }}
                className={
                  clsx(classes.cursor,
                    classes.headerItem,
                    item.title === category && classes.headerName,
                    item.category === 'separator' && classes.separator,
                    item.title === 'name' && classes.textLeft,
                  )
                }
                onClick={() => {
                  if (item.title === 'immersion') {
                    onCategoryChanged('immersion');
                  } else if (item.title === 'safety') {
                    onCategoryChanged('safety');
                  } else {
                    // index !== 0 && !sub && !search && onClickFilter(index)
                  }
                  index !== 0 && !sub && !search && onClickFilter(item.title)
                }}
              >
                {(item.title !== 'separator' && item.title.toLowerCase() === currentFilterArray.compareFilter.toLowerCase()) ?
                  <span style={{color:"#017AEF"}}>{item.title}</span>
                  :
                  item.title
                }
                {(item.title !== 'separator' && item.title !== '' && item.title.toLowerCase() === currentFilterArray.compareFilter.toLowerCase() ) && (
                  <Tooltip classes={tooltipClasses} title={item.title} placement="bottom" arrow>
                    <img
                      src={'/assets/icons/dashboard/sort.svg'}
                      className={clsx(classes.sortIcon, 'safari-backface', getFilerDirection(item) && classes.rotate180)}
                      alt={'svg'}
                    />
                  </Tooltip>
                )}
              </div>
            ) : (
              (item.title !== 'safety' && item.category !== 'safety') && (
                <div
                  key={index}
                  style={{ justifyContent: (item.title === 'name') ? 'left' : 'center', ...(item.title === 'name' ? { flex: 1 } : { width: (width <= 1025 ) ? item.mobileWidth : item.width }) }}
                  className={
                    clsx(classes.cursor,
                      classes.headerItem,
                      item.title === category && classes.headerName,
                      item.title === 'name' && classes.textLeft,
                    )
                  }
                  onClick={() => {
                    if (item.title === 'immersion') {
                      onCategoryChanged('immersion');
                    } else {
                      // index !== 0 && !sub && !search && onClickFilter(index)
                    }
                    index !== 0 && !sub && !search && onClickFilter(item.title)
                  }}
                >
                  {(item.title !== 'separator' && item.title.toLowerCase() === currentFilterArray.compareFilter.toLowerCase()) ?
                    <span style={{color:"#017AEF"}}>{item.title}</span>
                    :
                    item.title
                  }
                  {(item.title !== 'separator' && item.title !== '' && item.title.toLowerCase() === currentFilterArray.compareFilter.toLowerCase() ) && (
                    <Tooltip classes={tooltipClasses} title="Toggle SortB" placement="bottom" arrow>
                      <img
                        src={'/assets/icons/dashboard/sort.svg'}
                        className={clsx(classes.sortIcon, 'safari-backface', getFilerDirection(item) && classes.rotate180)}
                        alt={'svg'}
                      />
                    </Tooltip>
                  )}
                </div>
              )
            )
          )
        }
      </div>
      <div className={classes.headerBorder}/>
    </div>
  )
}
